module.exports = __webpack_public_path__ + "img/logo.d9ded0c0.png";